module.exports = __webpack_public_path__ + "static/img/Joe_h5.e87ede7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/Joe_h5.png
// module id = 4rAK
// module chunks = 34